import React from "react";

function AboutCard() {
  return (
    <div className="about-content">
      <h1 className="about-title">
        ABOUT <span className="gradient-text">ME</span>
      </h1>
      
      <p className="about-description">
        I'm an AI Engineer and Computer Science student at Brunel University London, 
        specializing in building intelligent systems that solve real-world problems. 
        My focus is on developing scalable AI platforms, machine learning applications, 
        and educational technology tools that make advanced AI accessible. 
        I'm passionate about bridging the gap between cutting-edge AI research 
        and practical applications that impact users' daily lives.
      </p>
    </div>
  );
}

export default AboutCard;

